// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_angular_material_fesm2022_slide-toggle_mjs":"dbc8c6788c901cd1","src_app_auth_auth_module_ts":"735c2873b05192f3","default-src_app_client-settings_client-settings_module_ts":"884d79ec11b3314f","src_app_incidents_incidents_module_ts":"1fc159a2a6985365"}[chunkId] + ".js";
};